import React, { useContext, useEffect, useState } from 'react';
import { RxFile } from 'react-icons/rx';
import { GoGlobe } from 'react-icons/go';
import { RiCloseFill } from 'react-icons/ri';
import iconMonitor from '../../assets/icon-monitor.svg';
// import cloudDrive from '../../assets/icon-cloud-drive.svg';
// import googleDrive from '../../assets/icon-google-drive.svg';
import Button from '../Button';
import { UploadModalStyle } from './UploadFileModal.styles';
import knowledgebaseService from '../../services/knowledgebaseService';
import { convertToFormData } from '../../helpers/common';
import UploadFile from '../UploadFile';
import agentService from '../../services/agentService';
import Toast from '../Toast';
import { TemporaryChatContext } from '../../Context/temporaryChatContext';

const UploadFileModal = ({ onClose, seprateUpdateID }) => {
  const [loading, setLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(null);
  const [isActive, setIsActive] = useState(true);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const { selectedAgent } = useContext(TemporaryChatContext);

  const handleToggle = () => {
    setIsActive(prev => !prev);
  };
  const handleDeleteFile = async index => {
    let payload;

    setDeleteLoading(index);
    try {
      if (seprateUpdateID) {
        payload = {
          agent_id: seprateUpdateID,
          file_id: index,
        };
      } else {
        payload = {
          agent_id: selectedAgent?.value,
          file_id: index,
        };
      }

      const resp = await knowledgebaseService.deleteKnowledgebase(payload);
      Toast({ type: 'success', message: resp?.detail });

      setUploadedFiles(prev => prev.filter((_, i) => _?.file_id !== index));
      setDeleteLoading(null);
    } catch (error) {
      console.log(error);
      setDeleteLoading(null);
    }
  };

  const formatFileName = (name, maxLength = 20) => {
    if (name.length <= maxLength) return name;

    const dotIndex = name.lastIndexOf('.');
    if (dotIndex === -1) return name; // no extension case

    const ext = name.slice(dotIndex); // extension
    const base = name.slice(0, dotIndex);

    // cut base but keep extension
    const shortBase = base.slice(0, maxLength - ext.length - 3); // leave space for "..."
    return `${shortBase}...${ext}`;
  };

  const handleFileUpload = async e => {
    let payload;
    try {
      setLoading(true);
      if (seprateUpdateID) {
        payload = { platform_id: 'tacticalabs', agent_id: seprateUpdateID };
      } else {
        payload = { platform_id: 'tacticalabs', agent_id: selectedAgent?.value };
      }
      const file = e.target.files[0];
      const body = {
        pdf_file: file,
      };
      const formData = convertToFormData(body);
      const res = await knowledgebaseService.KnowledgebaseUpload(payload, formData);
      Toast({ type: 'success', message: res?.detail });
      console.log(res, 'response after file upload');

      setUploadedFiles(prev => [
        ...prev,
        {
          file_id: res?.id,
          file_name: res?.files[0]?.file_name || 'when upload kb gives the file name replace it with res. file_name',
        },
      ]);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getAgentDocs = async () => {
    try {
      const resp = await agentService.getAgentDetail(seprateUpdateID ? seprateUpdateID : selectedAgent?.value);
      console.log(resp);
      if (resp?.detail?.files?.length > 0) {
        setUploadedFiles(resp?.detail?.files);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Helper: Convert bytes to KB/MB format
  const formatFileSize = bytes => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  useEffect(() => {
    getAgentDocs();
  }, []);
  return (
    <UploadModalStyle>
      <div className="holder">
        <div className="left-col">
          <ul className="link-list">
            <li>
              <a href="#files">
                <RxFile /> Files
              </a>
            </li>
            {/* <li>
              <a href="#links">
                <FiLink /> links
              </a>
            </li> */}
            <li>
              <a href="#web">
                <GoGlobe /> web
              </a>
            </li>
          </ul>
        </div>
        <div className="upload-col">
          <div id="files" className="content-box">
            <strong className="title">Upload Files</strong>
            <p>Supported files: text, data, code & images</p>
            <div className="drop-holder">
              <strong className="title">Drop files here, or import from</strong>
              <div className="wrap">
                {/* My Computer */}
                <label htmlFor="myComputer" className="upload-box">
                  {loading && <div className="loading"></div>}
                  <input id="myComputer" type="file" onChange={handleFileUpload} disabled={loading} />
                  <div className="icon-box">
                    <img src={iconMonitor} width="28" alt="img" />
                  </div>
                  <span className="label-text">My Computer</span>
                </label>

                {/* One Drive */}
                {/* <label htmlFor="cloudDrive" className="upload-box">
                  <input id="cloudDrive" type="file" />
                  <div className="icon-box">
                    <img src={cloudDrive} width="30" alt="img" />
                  </div>
                  <span className="label-text">One Drive</span>
                </label> */}

                {/* Google Drive */}
                {/* <label htmlFor="googleDrive" className="upload-box">
                  <input id="googleDrive" type="file" />
                  <div className="icon-box">
                    <img src={googleDrive} width="30" alt="img" />
                  </div>
                  <span className="label-text">Google Drive</span>
                </label> */}
              </div>
            </div>
          </div>

          {/* <div id="links" className="content-box">
            <strong className="title">Add Links</strong>
            <Form form={form}>
              <div className="input-holder">
                <Form.Item
                  noMargin
                  label="Link URL"
                  type="text"
                  rounded
                  lg
                  name="text"
                  placeholder="https://example.com"
                  rules={[{ required: true, message: 'Url is Required' }]}>
                  <Field />
                </Form.Item>
                <button className="btn-add">Add</button>
              </div>
            </Form>
            <span className="text">
              To search an entire website, enter the domain address. To search a specific page or subdirectory, enter
              it’s URL.
            </span>
          </div> */}

          <div id="web" className={`content-box ${isActive ? 'active' : ''}`}>
            <div className="text-area">
              <div className="box">
                <strong className="title">Search the Web</strong>
                <p>Tactica Lab will search the web for additional sources</p>
              </div>
              <div className={`btn-check ${isActive ? 'checked' : ''}`} onClick={handleToggle} />
            </div>
            <div className="search-area">
              <div className="text-area">
                <div className="box">
                  <strong className="title">Depth and Speed</strong>
                  <p>Choose the right balance between speed and detail.</p>
                </div>
              </div>
              <div className="textarea-holder">
                <label htmlFor="sources">Exclude specific web sources</label>
                <textarea id="sources" placeholder="Enter URLs to exclude" />
              </div>
              <span className="text">Press Enter to add a URL</span>
            </div>
          </div>
        </div>

        <div className="right-col">
          <strong className="title">Current Selection</strong>
          <span className="subtitle">Search</span>
          <div className="search-head">
            <div className="text-box">
              <GoGlobe className="icon" />
              <span className="text">Web Search</span>
            </div>
            <button className={`btn ${isActive ? 'checked' : ''}`} type="button" onClick={handleToggle}>
              <span className="text-on">On</span>
              <span className="text-off">Off</span>
            </button>
          </div>

          <div className="files-links">
            <strong className="title">Files & Links</strong>
            {uploadedFiles.length === 0 ? (
              <span className="subtitle">No files or links added</span>
            ) : (
              <ul className="uploaded-file-list">
                {uploadedFiles.map((elem, index) => (
                  <li key={index} title={elem?.file_name}>
                    <span className="file-name">{elem?.file_name}</span>{' '}
                    <span className="file-size">{elem?.file_size}</span>
                    {deleteLoading !== elem?.file_id && (
                      <button type="button" className="btn-delete" onClick={() => handleDeleteFile(elem?.file_id)}>
                        <RiCloseFill />
                      </button>
                    )}
                    {deleteLoading === elem?.file_id && (
                      <button type="button" className="btn-delete" style={{ cursor: 'not-allowed' }}>
                        <RiCloseFill style={{ visibility: 'hidden' }} />
                        {deleteLoading === elem?.file_id && <div className="loading"></div>}
                      </button>
                    )}
                  </li>
                ))}
              </ul>
            )}
          </div>
          <div className="col-footer">
            <span className="text">Total size</span>
            {/* <span className="files-size">{formatFileSize(totalSize)}</span> */}
          </div>
        </div>
      </div>

      <div className="btn-holder">
        <Button width="100px" variant="secondary" onClick={() => onClose()}>
          Cancel
        </Button>
        <Button width="140px" onClick={onClose}>
          Save & Close
        </Button>
      </div>
    </UploadModalStyle>
  );
};

export default UploadFileModal;
